import React, { PureComponent as Component } from 'react';
import {
	Col,
	Form,
	FormGroup,
	Input,
	InputGroup,
	InputGroupAddon,
	Button,
	Row,
	Label
} from 'reactstrap';
import propTypes from 'prop-types';

export default class SearchForm extends Component {
	render() {
		return (
			<Form onSubmit={this.props.onSubmit}>
				<FormGroup>
					<Col xs={12} sm={12} md={6} style={{ padding: 0 }}>
						<InputGroup>
							<Input
								type="text"
								placeholder="Search subcategory name"
								name="keyword"
								value={this.props.keyword}
								onChange={this.props.onInputChange}
							/>
							<InputGroupAddon addonType="append">
								<Button color="primary">Search</Button>
							</InputGroupAddon>
						</InputGroup>
					</Col>
				</FormGroup>
				<Row>
					<Col sm={6}>
						<FormGroup row>
							<Label sm={4}>Category</Label>
							<Col sm={8}>
								<Input
									type="select"
									value={this.props.category_id}
									name="category_id"
									onChange={this.props.onInputChangeAndSubmit}
								>
									<option value="">All</option>
									{
										this.props.categoryOptions.map(item => (
											<option key={item.value} value={item.value}>{item.label}</option>
										))
									}
								</Input>
							</Col>
						</FormGroup>
					</Col>
				</Row>
			</Form>
		);
	}
}

SearchForm.propTypes = {
	keyword: propTypes.string,
	category_id: propTypes.oneOfType([propTypes.number, propTypes.string]),
	categoryOptions: propTypes.array,
	onInputChange: propTypes.func,
	onInputChangeAndSubmit: propTypes.func,
	onSubmit: propTypes.func.isRequired
};

SearchForm.defaultProps = {
	keyword: '',
	category_id: '',
	categoryOptions: []
};
